<script>
export default {
  props: {
    maxZoom: {
      type: Number,
      default: 1
    },
    zoom: {
      type: Number,
      default: 0.5
    }
  },
  data() {
    return {
      focus: false,
      decreaseRatio: -0.05,
      increaseRatio: 0.05
    };
  },
  mounted() {
    window.addEventListener('mouseup', this.onStop, { passive: false });
    window.addEventListener('mousemove', this.onDrag, { passive: false });
    window.addEventListener('touchmove', this.onDrag, { passive: false });
    window.addEventListener('touchend', this.onStop, { passive: false });
  },
  destroyed() {
    window.removeEventListener('mouseup', this.onStop);
    window.removeEventListener('mousemove', this.onDrag);
    window.removeEventListener('touchmove', this.onDrag);
    window.removeEventListener('touchend', this.onStop);
  },
  methods: {
    onDrag(e) {
      if (this.focus) {
        const position = e.touches ? e.touches[0].clientX : e.clientX;
        const line = this.$refs.line;

        if (line) {
          const { left, width } = line.getBoundingClientRect();
          this.$emit(
            'change',
            Math.min(this.maxZoom, Math.max(0, position - left) / width)
          );
        }
        if (e.preventDefault) {
          e.preventDefault();
        }
      }
    },
    onStop() {
      this.focus = false;
    },
    onStart(e) {
      this.focus = true;
      this.onDrag(e);
    },
    changeZoom(ratio = 0.05) {
      const rawResult = this.zoom + ratio;
      const roundedResult = Math.round(rawResult * 100) / 100;

      if (roundedResult >= 0 && roundedResult <= 1) {
        this.$emit('change', roundedResult);
      }
    }
  }
};
</script>

<template>
  <div class="twitter-navigation">
    <div class="twitter-navigation__wrapper">
      <span
        class="twitter-navigation__icon twitter-navigation__icon-minus"
        @click="changeZoom(decreaseRatio)"
      />
      <div
        class="twitter-navigation__line-wrapper"
        ref="line"
        @mousedown="onStart"
        @touchstart="onStart"
      >
        <div class="twitter-navigation__line">
          <div
            class="twitter-navigation__fill"
            :style="{
              flexGrow: zoom
            }"
          ></div>
          <div
            class="twitter-navigation__circle"
            :class="{ 'twitter-navigation__circle--focus': focus }"
            :style="{
              left: `${zoom * 100}%`
            }"
          >
            <div
              class="twitter-navigation__inner-circle"
              :class="{ 'twitter-navigation__inner-circle--focus': focus }"
            ></div>
          </div>
        </div>
      </div>
      <span
        class="twitter-navigation__icon twitter-navigation__icon-plus"
        @click="changeZoom(increaseRatio)"
      />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '../../assets/sass/general/colors'

.twitter-navigation
  display: flex
  width: 100%
  align-items: center
  justify-content: center

  &__icon
    width: 20px
    height: 20px
    cursor: pointer

    &-plus
      background: url('~@/assets/img/ZoomSlider/plus.svg')
      background-repeat: no-repeat
      background-size: cover

    &-minus
      background: url('~@/assets/img/ZoomSlider/minus.svg')
      background-repeat: no-repeat
      background-size: cover

  &__wrapper
    display: flex
    align-items: center
    justify-content: center
    max-width: 400px
    width: 100%

  &__zoom-icon
    height: 18.75px
    width: 18.75px
    fill: white
    flex-shrink: 0
    &--left
      margin-right: 10px

    &--right
      margin-left: 10px


  &__line-wrapper
    width: 256px
    height: 20px
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center
    border-radius: 5px
    cursor: pointer
    padding: 0 12px

  &__line
    background: rgba($blue-natural, 0.24)
    height: 8px
    width: 100%
    border-radius: 48px
    display: flex
    position: relative
    align-items: center

  &__fill
    background: $blue-natural
    border-radius: 48px
    align-self: stretch
    flex-basis: auto
    flex-direction: column
    flex-shrink: 0

  &__circle
    width: 30px
    height: 30px
    margin-left: -15px
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
    position: absolute
    transition-duration: 0.2s
    transition-property: background-color, box-shadow
    &:hover
      background-color: rgba(29, 161, 242, 0.1)

    &--focus
      background-color: rgba(29, 161, 242, 0.2)


  &__inner-circle
    width: 16px
    height: 16px
    border-radius: 50%
    background-color: #FFF
    transform: scale(1)
    transition-duration: 0.1s
    transition-property: transform
    box-shadow: rgba(101, 119, 134, 0.7) 0px 0px 7px, rgba(101, 119, 134, 0.35) 0px 1px 3px 1px
    &--focus
      transform: scale(1.2)
</style>
